import React, { Component } from "react";
import { Modal, Card, DropZone } from "@shopify/polaris";
import $ from "jquery";
import { toastr } from "./toastr.js";
import Attachment from "./Attachment.js";
import API from "../API";

class UploadModal extends Component {
	constructor(props) {
		super(props);

		this.state = { saving: false, files: [] };
	}

	componentWillReceiveProps(props) {
		if (props.open != this.state.open) {
			this.setState({ open: props.open, files: [] });
		}
	}

	// eslint-disable-next-line react/no-unused-class-component-methods
	updateForm(field, value) {
		var formState = this.state.form;
		formState[field] = value;

		this.setState({ form: formState });
	}

	saveForm() {
		this.setState({ saving: true });
		API.post("/api/uploads.json", { files: this.state.files, as: this.props.as })
			.then((result) => {
				if (result.data.error) {
					return;
				}
				if (!this.props.disabledToast) toastr.success("Laddade upp filer");
				this.setState({ saving: false });
				this.props.onSelect(result.data.uploads);
			})
			.catch((error) => {
				toastr.error(error);
				this.setState({ saving: false });
			});
	}

	addFile(file, event) {
		var data = event.target.result;
		var files = this.state.files;
		files.push({ name: file.name, type: file.type, size: file.size, data });
		this.setState({ files });
	}

	updateFile(index, file) {
		this.state.files[index] = file;
		this.setState({ files: this.state.files });
	}

	componentDidUpdate() {
		$(".upload-modal-wrapper").closest("[data-portal-id]").addClass("modal-top");
	}

	render() {
		// const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
		return (
			<Modal
				open={this.state.open}
				onClose={this.props.onClose}
				title="Välj fil"
				secondaryActions={[].concat(this.props.secondaryActions || []).concat([
					{
						content: "Stäng",
						onAction: this.props.onClose,
					},
				])}
				primaryAction={{
					content: "Välj",
					disabled: !this.state.files.length,
					loading: this.state.saving,
					onAction: this.saveForm.bind(this),
				}}
			>
				<div className="upload-modal-wrapper">
					<DropZone
						openFileDialog={this.state.openFileDialog}
						onFileDialogClose={() => {
							this.setState({ openFileDialog: false });
						}}
						onDrop={(files, acceptedFiles, rejectedFiles) => {
							for (var i = 0; i < acceptedFiles.length; i++) {
								var reader = new FileReader();
								reader.onload = this.addFile.bind(this, acceptedFiles[i]);
								reader.readAsDataURL(acceptedFiles[i]);
							}
						}}
						allowMultiple={this.props.allowMultiple}
					>
						{this.state.files.length ? (
							<Card sectioned>
								{this.state.files.map((file, index) => {
									return <Attachment editable onChange={this.updateFile.bind(this, index)} key={index} file={file} />;
								})}
							</Card>
						) : (
							<DropZone.FileUpload actionTitle="Välj fil" actionHint="Eller dra och släpp en fil" />
						)}
					</DropZone>
				</div>
			</Modal>
		);
	}
}
export default UploadModal;
UploadModal.defaultProps = {
	allowMultiple: true,
};
